import { Button, H4, Link } from '@/_components';
import { googleAnalytics4 } from '@/_shared';
import AnimatedSlider from '@/_shared/animations/animated-slider';

function Login() {
  const handleContactSupport = () => {
    googleAnalytics4.event({ category: 'Support', action: 'Contact Support' });
  };

  return (
    <>
      <AnimatedSlider className="w-full" key="0">
        <div className="mb-12 text-center">
          <H4>Welcome to Achieve!</H4>
        </div>
      </AnimatedSlider>

      <div className="mt-4">
        <Link
          underline="none"
          onClick={handleContactSupport}
          href="https://www.achievetestprep.com/customer-support"
          target="_blank"
        >
          <Button variant="text">Contact Support</Button>
        </Link>
      </div>
    </>
  );
}

export default Login;
